import React from 'react';
import { useForm } from 'react-hook-form';
import Changepasswordform from './Changepasswordform';
import ChangepasswordSuccess from './Changepasswordsuccess';
import { ChangePasswordprops, FormValues } from './Changepassword.types';
import Form from '../../../components/Form/Form';
import { changePasswordService } from '../../../services/Auth/Auth';
import { AuthContext } from '../../../context/Auth/Auth';
import { Changepasswordcontext } from '../../../context/Changepassword/Changepassword';

const Changepassword = ({ showModalError }: ChangePasswordprops) => {
  const { register, handleSubmit, formState } = useForm<FormValues>();
  const { username, resetPasswordToken } = React.useContext(Changepasswordcontext);
  const { isLoggedIn, token } = React.useContext(AuthContext);
  const [success, setSuccess] = React.useState<boolean>(false);

  const changePassword = React.useCallback(
    async ({ password, totpCode }: FormValues) => {
      const requestUrl = isLoggedIn
        ? 'https://sistemas.udea.edu.co/api/ldap/changepassword'
        : 'https://sistemas.udea.edu.co/api/ldap/forgotpassword/change';
      const requestToken = isLoggedIn ? token : resetPasswordToken;
      const requestData = isLoggedIn ? { password, totpCode } : { username, password };
      try {
        await changePasswordService(requestData, requestToken, requestUrl);
        setSuccess(true);
      } catch (error) {
        if (error instanceof Error) showModalError(error.message);
      }
    },
    [username, isLoggedIn, token, resetPasswordToken, showModalError]
  );

  const onSubmit = React.useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      handleSubmit(changePassword)();
    },
    [handleSubmit, changePassword]
  );

  return (
    <React.Fragment>
      {success ? (
        <ChangepasswordSuccess />
      ) : (
        <Form form={{ title: 'Cambiar contraseña', description: isLoggedIn ? 'Actualiza la contraseña asociada a tu cuenta institucional.' : 'Elige una nueva contraseña para recuperar el acceso a tu cuenta.', onSubmit }}>
          <Changepasswordform register={register} formState={formState} />
        </Form>
      )}
    </React.Fragment>
  );
};

export default Changepassword;
